<template>
  <div class="template-maker">
    <div v-if="!preview" class="tools-zone">
      <div>
        {{$t('dash.template.title')}}:
        <div class="custom_link">
         <input type="text" v-model="title" placeholder="Test de titre">
        </div>

        <vs-select
          v-if="typePost == 'image'"
          :label="$t('dash.template.image.content_text')"
          v-model="textProperties.content"
        >
          <vs-select-item value="title" :text="$t('dash.template.image.content_text.title')" />
          <vs-select-item value="description" :text="$t('dash.template.image.content_text.description')" />
        </vs-select>

        <vs-select
          v-if="typePost == 'image'"
          :label="$t('dash.template.image.content_text_style_important')"
          v-model="textProperties.style_important"
        >
          <vs-select-item value="enabled" :text="$t('dash.template.image.content_text_style_important.enabled')" />
          <vs-select-item value="disabled" :text="$t('dash.template.image.content_text_style_important.disabled')" />
        </vs-select>

        <div style="display: flex; alignItems: center;" v-if="typePost == 'image' && textProperties.style_important == 'enabled'">
          {{$t('dash.template.image.content_text_style_important.background_color')}} 
            <input style="margin-left: 10px" type="color" v-model="textProperties.style_important_backgroundColor">
        </div>
        <div style="display: flex; alignItems: center;" v-if="typePost == 'image' && textProperties.style_important == 'enabled'">
          {{$t('dash.template.image.content_text_style_important.font_color')}} 
            <input style="margin-left: 10px" type="color" v-model="textProperties.style_important_fontColor">
        </div>


        <vs-select
          v-if="typePost !== 'image'"
          :color="textProperties.color"
          :label="$t('dash.template.color')"
          v-model="textProperties.color"
          :style="{color: textProperties.color === '#FFFFFF' ? 'black' : textProperties.color}"
        >
          <vs-select-item :key="item.value" :value="item.hex" :text="item.value" v-for="item in possiblesColors" />
        </vs-select> 
        <vs-select
            v-if="typePost !== 'image'"
            :label="$t('dash.template.size')"
            v-model="textProperties.size"
          >
          <vs-select-item :key="item" :value="item" :text="item" v-for="item in possiblesSizes" />
        </vs-select>
        <vs-select
            :label="$t('dash.template.font')"
            v-model="textProperties.font"
          >
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in possiblesFonts" />
        </vs-select>
        <vs-select
            v-if="typePost !== 'image'"
            :label="$t('dash.template.align')"
            v-model="textProperties.align"
          >
          <vs-select-item :key="item" :value="item" :text="item" v-for="item in possiblesAlign" />
        </vs-select>
      </div>
      <div style="display: flex; alignItems: center;" v-if="typePost !== 'image'">
        {{$t('dash.template.background')}} 
          <input style="margin-left: 10px" type="color" v-model="backgroundColor">
      </div>
      <!-- <div style="display: flex; alignItems: center;"  v-if="typePost == 'image'">
          <vs-select
            :label="$t('dash.template.image.format')"
            v-model="formatImage"
          >
          <vs-select-item value="portrait" :text="$t('dash.template.image.portrait')" />
          <vs-select-item value="paysage" :text="$t('dash.template.image.paysage')" />
          <vs-select-item value="4/5" :text="$t('dash.template.image.4/5')" />
        </vs-select>
      </div> -->
      <div class="custom_link" v-if="typePost != 'image'">
        {{$t('dash.template.custom_link')}}
          <input type="text" v-model="custom_cta">
          <!-- <vs-select
            :label="$t('dash.template.link_style')"
            v-model="linkStyle"
          >
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in possibleLinkStyles" />
        </vs-select> -->
      </div>
      <!-- <div style="display: flex; alignItems: center;">
        {{$t('dash.template.image')}}: 
          <vs-switch color="dark" vs-icon-on="check_box" vs-icon-off="block" @click.prevent >
            <span slot="on">Cover</span>
            <span slot="off">Contain</span>
          </vs-switch>
      </div> -->
      
      <div>
        {{$t('dash.template.layers')}}:
          <label class="layers-config">
            <div class="add-layer">Add new layer</div>
            <input type="file" accept="image/*" @change="addNewLayer($event, index)">
          </label>
          <div class="layers-preview">
            <div class="layer-preview" v-for="(layer, i) in layers" :key="i" >
              <span class="remove-layer" @click="removeLayer(i)">x</span>
              <img :src="layer.reader || layer.url" :alt="i">
            </div>
          </div>
        </div>

      <!-- <div style="cursor: pointer; border: 1px solid black; backgroundColor: white;" @click="testTemplateBack">SEND TEST</div> -->
    </div>
    <div id="template-zone" class="template-zone" :style="{backgroundColor, marginLeft: preview && '0px'}" :class="[{'paysage': typePost == 'image' && formatImage == 'paysage', 'f4sur5': typePost == 'image' && formatImage == '4/5' }]">
      <!-- <p :style="{color: textProperties.color, fontSize: textProperties.size+'px', textAlign: textProperties.align || 'center', border: !preview && 'dashed 1px black'}" :class="`title-news font${textProperties.font}`">{{title ? title : (listNews && listNews.length ? (textProperties.content == 'title' ? listNews[0].title : listNews[0].description) : 'Test de titre')}}</p> -->
      <p :style="{color: textProperties.color, fontSize: textProperties.size+'px', textAlign: textProperties.align || 'center', border: !preview && 'dashed 1px black', lineHeight: '26px'}" :class="`title-news font${textProperties.font}`" v-if="typePost == 'image'" v-html="getTextInImage()"></p>
      <p :style="{color: textProperties.color, fontSize: textProperties.size+'px', textAlign: textProperties.align || 'center', border: !preview && 'dashed 1px black'}" :class="`title-news font${textProperties.font}`" v-else>{{title ? title : (listNews && listNews.length ? (textProperties.content == 'title' ? listNews[0].title : listNews[0].description) : 'Test de titre')}}</p>
      <img
        class="image-news"
        :src="image ? image : (listNews && listNews.length ? listNews[0].enclosure : require('../../assets/img/template_image.jpg'))"
        alt="IMAGE"
      />
      <img class="image-layer" :id="`layer-${i}`" v-for="(layer, i) in layers" :key="i" :src="layer.reader || layer.url" :alt="i">
      <div id="link-container" :class="`link-container ${linkStyle === 1 ? 'style-color-1' : linkStyle === 2 ? 'style-color-2' : linkStyle === 3 ? 'style-color-3' : ''}`"  v-if="typePost != 'image'"> 
        <img class="link-img" src="../../assets/img/icon_instagram_link.svg" alt="Link">
        <p class="link-txt">{{custom_cta ? custom_cta.toUpperCase() : (link ? link.split('/')[2].toUpperCase() : 'LINK.COM')}}</p>
      </div>
      <!-- <story-maker :screenWidth="281" :screenHeight="500"></story-maker> -->
    </div>
  </div>
</template>

<script>
// import StoryMaker from './StoryMaker.vue'
import interact from 'interactjs'
import Posts from './../mixins/Posts'

export default {
  components: {  },

  mixins: [Posts],

  mounted() {
    this.findNewsParsed()
    let coefReal = 3.84
    if(['image', 'standard'].includes(this.typePost)) {
      if(!this.configuration || !this.configuration.text) this.configuration = {text:{}, formatImage: '4/5', layers: []}
      this.formatImage = '4/5'
      coefReal = 2.7
      this.configuration.text.x = 0
      this.configuration.text.y = 350
      this.configuration.text.w = 400
      this.configuration.text.h = 150
    }

    if (this.configuration) {
      this.formatImage = this.configuration.formatImage
      if(['image', 'standard'].includes(this.typePost)) {

        if(this.formatImage == 'paysage') 
          coefReal = 1.214
        else if(this.formatImage == '4/5') {
          coefReal = 2.7
          this.configuration.text.x = 0
          this.configuration.text.y = 350
          this.configuration.text.w = 400
          this.configuration.text.h = 150
        }
      }

      this.layers = this.configuration.layers.map(e => {
        return {
          x: e.x/coefReal,
          y: e.y/coefReal,
          w: e.w/coefReal,
          h: e.h/coefReal,
          url: e.url
        };
      });
      if (this.configuration.link && this.configuration.link.custom_cta) {
        this.custom_cta = this.configuration.link.custom_cta;
      }
      if (this.configuration.link && this.configuration.link.style) {
        this.linkStyle = parseInt(this.configuration.link.style);
      }
      this.backgroundColor = this.configuration.background;
      this.textProperties = {
        color: this.configuration.text.color,
        size: this.configuration.text.size,
        font: this.configuration.text.font,
        background: this.configuration.text.background,
        align: this.configuration.text.align || 'center',
        content: this.configuration.text.content || 'title',
        style_important: this.configuration.text.style_important || 'disabled',
        style_important_backgroundColor: this.configuration.text.style_important_backgroundColor || '#FFFFFF',
        style_important_fontColor: this.configuration.text.style_important_fontColor || '#000000',
      };
      let img = document.getElementsByClassName('image-news')[0];
      let txtEl = document.getElementsByClassName('title-news')[0];
      let linkEl = document.getElementById('link-container');

      if(this.configuration.image) {
        img.style.width = `${this.configuration.image.w / coefReal}px`;
        img.style.height = `${this.configuration.image.h / coefReal}px`;
        img.style.left = `${this.configuration.image.x / coefReal}px`;
        img.style.top = `${this.configuration.image.y / coefReal}px`;
      }

      if (this.preview && !this.configuration.text.newWay) {
        txtEl.style.left = `${(this.configuration.text.x / 5.12)}px`
        txtEl.style.top = `${(this.configuration.text.y / 5.12)}px`
        txtEl.style.transform = 'translate(-50%, -50%)';
        this.textProperties.size = this.textProperties.size * (30/this.title.length) + (this.title.length*0.01)
      } else if(this.formatImage == '4/5') {
        txtEl.style.left = `${(this.configuration.text.x)}px`
        txtEl.style.top = `${(this.configuration.text.y)}px`
        txtEl.style.width = `${(this.configuration.text.w)}px`
        txtEl.style.height = `${(this.configuration.text.h)}px`
        txtEl.style.background = `linear-gradient(rgba(0, 0, 0, 0.2),rgba(0, 0, 0, 0.6))`
        txtEl.style.padding = `10px`
      } else {
        txtEl.style.left = `${((this.configuration.text.x / 5.12) - (this.configuration.text.w / 5.12 / 2))}px`
        txtEl.style.top = `${((this.configuration.text.y / 5.12) - (this.configuration.text.h / 5.12 / 2))}px`
        if (this.configuration.text.newWay) {
          txtEl.style.width = `${this.configuration.text.w / 5.12}px`
        }
      }
      if(this.configuration.link) {
        if (this.preview && !this.configuration.text.newWay) {
          linkEl.style.left = `${(this.configuration.link.x / 5.12)}px`
          linkEl.style.top = `${(this.configuration.link.y / 5.12)}px`
          linkEl.style.transform = 'translate(-50%, -50%)';
        } else {
          linkEl.style.left = `${((this.configuration.link.x / 5.12) - (this.configuration.link.w / 5.12 / 2))}px`
          linkEl.style.top = `${((this.configuration.link.y / 5.12) - (this.configuration.link.h / 5.12 / 2))}px`
        }
      }

      this.$nextTick(_ => {
        this.layers.forEach((e,i) => {
          let elmt = document.getElementById(`layer-${i}`);
          elmt.style.width = `${e.w}px`;
          elmt.style.height = `${e.h}px`;
          elmt.style.left = `${e.x}px`;
          elmt.style.top = `${e.y}px`;
        });
      })
      
    }
    if (!this.preview) {
      if(this.typePost !== 'image') {
        interact('.image-news')
        .resizable({
          edges: { left: true, right: true, bottom: true, top: true },
          listeners: { move: this.imageResizeHandle },
          modifiers: [
            interact.modifiers.restrictEdges({
              outer: 'parent',
            }),
            interact.modifiers.restrictSize({
              min: { width: 100, height: 50 }
            })
          ]
        })
        .draggable({
          listeners: { move: this.imageDragHandle },
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: 'parent'
            })
          ]
        });
      }

        interact('.image-layer')
        .resizable({
          edges: { left: true, right: false, bottom: false, top: true },
          listeners: { move: this.imageResizeHandle },
          modifiers: [
            interact.modifiers.restrictEdges({
              outer: 'parent',
            }),
            interact.modifiers.restrictSize({
              min: { width: 20, height: 20 },
              // max: { width: 300, height: 200 }
            })
          ]
        })
        .draggable({
          listeners: { move: this.imageDragHandle },
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: 'parent'
            })
          ]
        });
      
      if(this.typePost !== 'image') {
        interact('.title-news')
        .resizable({
          edges: { left: true, right: true, bottom: false, top: false },
          listeners: { move: (i) => this.imageResizeHandle(i, false) },
          modifiers: [
            interact.modifiers.restrictEdges({
              outer: 'parent',
            }),
            interact.modifiers.restrictSize({
              min: { width: 20, height: 20 },
              // max: { width: 300, height: 200 }
            })
          ]
        })
        .draggable({
          listeners: { move: this.imageDragHandle },
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: 'parent'
            })
          ]
        });
      }
      
      interact('.link-container')
      .draggable({
        listeners: {move: this.imageDragHandle},
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: 'parent'
          })
        ]
      })
    }
  },

  props: {
    configuration: Object,
    image: {type: String, default: null},
    title: {type: String, default: null},
    link: {type: String, default: null},
    preview: {type: Boolean, default: false},
    typePost: {type: String, default: null},
    feed: {type: Object, default: null},
  },

  data() {
    return {
      possiblesColors: [
        {value: this.$t('instagram.color.white'), hex: "#FFFFFF"},
        {value: this.$t('instagram.color.yellow'), hex: "#fdcb5c"},
        {value: this.$t('instagram.color.orange'), hex: "#fd8d32"},
        {value: this.$t('instagram.color.red'), hex: "#db565b"},
        {value: this.$t('instagram.color.pink'), hex: "#d10869"},
        {value: this.$t('instagram.color.purple'), hex: "#a207ba"},
        {value: this.$t('instagram.color.blue'), hex: "#0095ff"},
        {value: this.$t('instagram.color.green'), hex: "#58c322"},
        {value: this.$t('instagram.color.black'), hex: "#000000"},
      ],

      possiblesAlign: ["left", "center", "right"],

      possiblesSizes: [ ...Array(22).keys() ].map(e => e + 12).filter(e => e % 2 === 0),

      possibleLinkStyles: [
        {text: 'Style 1', value: 0},
        {text: 'Style 2', value: 1},
        {text: 'Style 3', value: 2},
        {text: 'Style 4', value: 3},
      ],

      possiblesFonts: [
        {text: 'Araboto', value: 1},
        {text: 'Aveny-T', value: 2},
        {text: 'Cosmopolitan Script', value: 3},
        {text: 'Courier Bold', value: 4},
        // {text: 'font 5', value: 5},
        // {text: 'font 6', value: 6},
        // {text: 'font 7', value: 7},
        // {text: 'font 8', value: 8},
        // {text: 'font 9', value: 9},
        {text: 'Lora', value: 10},
        {text: 'TitlingGothicFB Cond Bold', value: 11},
        {text: 'Zing Rust', value: 15},
      ],

      textProperties: {
        color: '#FFFFFF',
        size: 22,
        font: 1,
        background: null,
        align: 'center',
        content: 'title'
      },

      layers: [],

      backgroundColor: '#000000',

      formatImage: "portrait",
      listNews: [],

      custom_cta: '',
      linkStyle: 0,
      
    }
  },

  methods: {

/**
 * Faire une methode qui permet de recuperer les info
 * Dans Bot au moment de la validation recuperer info en appelant la methode (desssus)
 * Puis envoyer crééer la template en appelant l'engine
 * et ajouter à StoryTemplate en bdd, les info : layer(x, y ,w, h, url), image(x,y,w,h), text(x,y,font,size,color), link(x,y)
 * Lors d'un post (lambda B + engine post) recuperer les info en BDD
 * Si template configuré alors utilisé les info pour construire les image et set le variable text et link
 * Modifier pour que la template 1 fonctionne de la meme maniere ? 
 * 
 */

    async testTemplateBack() {
      let img = document.getElementsByClassName('image-news')[0];

      let image = {
          x: parseInt((img.offsetLeft + parseFloat(img.getAttribute('data-x') || 0)) * 3.84),
          y: parseInt((img.offsetTop + parseFloat(img.getAttribute('data-y') || 0)) * 3.84),
          w: parseInt(img.offsetWidth * 3.84),
          h: parseInt(img.offsetHeight * 3.84),
        };
      console.log(image);
    },

    findNewsParsed() {
      if(this.feed)
        this.listNewsParsed(this.feed.uid).then(res => {
          console.log('findNewsParsed', res.body)
          if(res.body.news){
            this.listNews = res.body.news
          }
        })
    },

    // Fonction pour détecter les mots importants (en évitant les mots consécutifs)
    findImportantWords(text, count = 3) {
      const stopWords = ['le', 'la', 'les', 'un', 'une', 'des', 'et', 'ou', 'de', 'du', 'à', 'dans', 'pour', 'sur', 'avec', 'par', 'en', 'est', 'sont', 'a', 'ont', 'the', 'and', 'of', 'to', 'is', 'it'];

      const words = text.toLowerCase().split(/\s+/);
      const wordCounts = {};
      const wordPositions = {}; // Garder la trace des positions dans le texte

      // Compter la fréquence et calculer un score, et mémoriser les positions
      words.forEach((word, index) => {
        const cleanWord = word.replace(/[^a-zàâçéèêëîïôûùüÿñæœ0-9]/gi, '');
        if (cleanWord.length > 2) {
          const isStopWord = stopWords.includes(cleanWord.toLowerCase());
          // Les stop words ont un score réduit mais pas éliminé
          const penalty = isStopWord ? 0.3 : 1;

          if (!wordCounts[cleanWord]) {
            wordCounts[cleanWord] = 0;
            wordPositions[cleanWord] = [];
          }
          wordCounts[cleanWord] += penalty;
          wordPositions[cleanWord].push(index); // Mémoriser la position
        }
      });

      // Trier par score (longueur * fréquence)
      const candidates = Object.entries(wordCounts)
        .map(([word, freq]) => ({
          word: word.toLowerCase(),
          score: word.length * freq,
          positions: wordPositions[word]
        }))
        .sort((a, b) => b.score - a.score);

      // Sélectionner les mots en évitant les mots consécutifs
      const selectedWords = [];
      const selectedPositions = new Set();

      for (const candidate of candidates) {
        if (selectedWords.length >= count) break;

        // Vérifier si ce mot n'est pas adjacent à un mot déjà sélectionné
        let isAdjacent = false;
        for (const pos of candidate.positions) {
          if (selectedPositions.has(pos - 1) || selectedPositions.has(pos + 1)) {
            isAdjacent = true;
            break;
          }
        }

        if (!isAdjacent) {
          selectedWords.push(candidate.word);
          // Ajouter toutes les positions de ce mot
          candidate.positions.forEach(pos => selectedPositions.add(pos));
        }
      }

      console.log(`Mots importants sélectionnés (non consécutifs): ${selectedWords.join(', ')}`);
      return selectedWords;
    },

    getTextInImage() {

      let msg = this.title ? this.title : (this.listNews && this.listNews.length ? (this.textProperties.content == 'title' ? this.listNews[0].title : this.listNews[0].description) : 'Test de titre')

      if(this.textProperties.style_important == 'enabled') {
        for(let word of this.findImportantWords(msg)) {
          const regex = new RegExp(word, 'i')
          msg = msg.replace(regex, `<span class="style_important" style="padding: 0 5px; background:${this.textProperties.style_important_backgroundColor}; color:${this.textProperties.style_important_fontColor}">$&</span>`)
        }
      }
      
      return msg
    },


    async getTemplateInformations() {
      const { VUE_APP_API_HOST } = process.env
      let img = document.getElementsByClassName('image-news')[0];

      for (let k = 0; k < this.layers.length; k++) {
        if (this.layers[k].url) {
          continue
        }
        let formData = new FormData()
        formData.append('file', this.layers[k].file)

        await this.$http
          .post(`${VUE_APP_API_HOST}/posts/upload/file`, formData, {
            progress: (e) => {
                if (e.lengthComputable) {
                    console.log(Math.floor(e.loaded / e.total * 100));
                    this.percentUpload = Math.floor(e.loaded / e.total * 100)
                }
            }
          })
          .then(res => {
            this.layers[k].url = res.body.file_url
          }, err => err)
      }
      
      let coefReal = 3.84
      if(['image', 'standard'].includes(this.typePost)) {
        if(this.formatImage == 'paysage') 
          coefReal = 1.214
        else if(this.formatImage == '4/5')
          coefReal = 2.7
      }

      let bodylayers = this.layers.map((e,i) => {
        let element = document.getElementById(`layer-${i}`);
        return {
          x: parseInt((element.offsetLeft + parseFloat(element.getAttribute('data-x') || 0)) * coefReal),
          y: parseInt((element.offsetTop + parseFloat(element.getAttribute('data-y') || 0)) * coefReal),
          w: parseInt(element.offsetWidth * coefReal),
          h: parseInt(element.offsetHeight * coefReal),
          url: e.url
        }
      });

      let txtEl = document.getElementsByClassName('title-news')[0];
      let linkEl = document.getElementById('link-container');
      const body = {
        image: ['image', 'standard'].includes(this.typePost) && this.formatImage == '4/5' 
                      ? {
                        x: 0,
                        y: 0,
                        w: 1080,
                        h: 1350,
                      }
                      : {
                        x: parseInt((img.offsetLeft + parseFloat(img.getAttribute('data-x') || 0)) * coefReal),
                        y: parseInt((img.offsetTop + parseFloat(img.getAttribute('data-y') || 0)) * coefReal),
                        w: parseInt(img.offsetWidth * coefReal),
                        h: parseInt(img.offsetHeight * coefReal),
                      },
        layers: bodylayers,
        text: ['image', 'standard'].includes(this.typePost) && this.formatImage == '4/5' 
                      ? {
                        x: 0,
                        y: 945,
                        w: 1080,
                        h: 405,
                        newWay: true,
                        ...this.textProperties
                      }
                      : {
                        x: parseInt(((txtEl.offsetLeft + parseFloat(txtEl.getAttribute('data-x') || 0)) + parseFloat(txtEl.offsetWidth / 2)) * (['image', 'standard'].includes(this.typePost) && this.formatImage == 'paysage' ? 1.214 : 5.12)),
                        y: parseInt(((txtEl.offsetTop + parseFloat(txtEl.getAttribute('data-y') || 0)) + parseFloat(txtEl.offsetHeight / 2)) * (['image', 'standard'].includes(this.typePost) && this.formatImage == 'paysage' ? 1.214 : 5.12)),
                        w: parseInt(txtEl.offsetWidth * (['image', 'standard'].includes(this.typePost) && this.formatImage == 'paysage' ? 1.214 : 5.12)),
                        h: parseInt(txtEl.offsetHeight * (['image', 'standard'].includes(this.typePost) && this.formatImage == 'paysage' ? 1.214 : 5.12)),
                        newWay: true,
                        ...this.textProperties
                      },
        link: ['image', 'standard'].includes(this.typePost) ? null : {
          x: parseInt(((linkEl.offsetLeft + parseFloat(linkEl.getAttribute('data-x') || 0)) + parseFloat(linkEl.offsetWidth / 2)) * 5.12),
          y: parseInt(((linkEl.offsetTop + parseFloat(linkEl.getAttribute('data-y') || 0)) + parseFloat(linkEl.offsetHeight / 2)) * 5.12),
          w: parseInt(linkEl.offsetWidth * 5.12),
          h: parseInt(linkEl.offsetHeight * 5.12),
          custom_cta: this.custom_cta,
          style: this.linkStyle,
        },
        background: this.backgroundColor,
        formatImage: this.formatImage
      }
      return body;
    },

    removeLayer(idx) {
      this.layers.splice(idx, 1);
    },

    addNewLayer(event, index) {
      console.log(event.target.files, index);
      let files = event.target.files;
      console.log(files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        this.layers.push({
          reader: e.target.result,
          file: files[0],
        })
      };
      reader.readAsDataURL(files[0]);
    },

    imageResizeHandle(event, height=true) {
      let target = event.target
      let x = parseFloat(target.getAttribute('data-x')) || 0
      let y = parseFloat(target.getAttribute('data-y')) || 0

      // update the element's style
      target.style.width = event.rect.width + 'px'
      if (height) target.style.height = event.rect.height + 'px'
      

      // translate when resizing from top or left edges
      x += event.deltaRect.left
      y += event.deltaRect.top

      target.style.transform = 'translate(' + x + 'px,' + y + 'px)'

      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
      // target.textContent =
      //   Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height)
    },

    imageDragHandle(event) {
      var target = event.target
      // keep the dragged position in the data-x/data-y attributes
      var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
      var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

      // translate the element
      target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
    }
  }
}
</script>
